module.exports = __webpack_public_path__ + "img/white_notes.7a28fa55.svg";